// src/components/Footer.js
import React from "react";
import "./Footer.css";
//import { FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { FiMapPin, FiMail } from "react-icons/fi";

const Footer = () => {
  return (
    <footer className="Footer">
      <div className="footer-container">
        <div className="footer-top">
          
          <div className="footer-column">
            <h3 className="footer-title">SPACETIMEAI LTD</h3>

            <div className="footer-info">
              <FiMapPin className="icon" />
              <div>
                <p>CEGE, Chadwick Building University</p>
                <p>College London London WC1E 6BT</p>
              </div>
            </div>

            <div className="footer-info">
              <FiMail className="icon" />
              <p>info@spacetimeai.com</p>
            </div>
          </div>

          <div className="footer-column">
            <h4 className="footer-subtitle">Solutions</h4>
              <a href="/solutions/spacetime-city-twin">Spacetime CityTwin™</a>
              <a href="/solutions/spacetime-safe-city">Spacetime SafeCity™</a>
              <a href="/solutions/spacetime-infra-plan">Spacetime InfraPlan™</a>
          </div>

          <div className="footer-column">
            <h4 className="footer-subtitle">Company</h4>
            <a href="/about">About</a>
            <a href="/contact">Contact</a>

            {/*}
            <div className="social-icons">
              <a href="#"><FaLinkedinIn /></a>
              <a href="#"><span className="icon-letter">M</span></a>
              <a href="#"><FaTwitter /></a>
            </div>
            */}
          </div>
        </div>

        <div className="footer-bottom">
          © 2026 SpaceTimeAI Ltd. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
